var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"cbs-circle-steps flex"},_vm._l((_vm.value),function(item,index){return _c('li',{key:index,class:[
				'item cbs-circle-steps__item font-bold inline-block text-center rounded-full h-10 w-10 sm:h-12 sm:w-12 flex items-center justify-center',
				{
                    'text-white cursor-pointer': item.isEnable,
					'opacity-50': !item.isActive,
                    'item--active bg-solid-primary': item.isActive,
                    'bg-solid-green-2': item.isEnable && !item.isActive,
					'item--disabled bg-gray-5 cursor-not-allowed': !item.isEnable
				}
			],on:{"click":function($event){item.isEnable && !item.isActive && _vm.$emit('onClickStep', item, index)}}},[_c('span',[_vm._v(_vm._s(item.text))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }